import React from "react";
import classNames from "classnames";

import { PlanetIcon, TickIcon } from "../Icons";
import SelectInput from "../../components/SelectInput";

import styles from "./LanguageSwitcher.module.scss";

export interface LanguageSwitcherProps {
    value: string;
    options: { label: string; value: string }[];
    onChange: (e: React.SyntheticEvent, value: unknown) => void;
    style?: React.CSSProperties;
    width?: number;
    dropDownWidth?: number;
};
const LanguageSwitcher = (props: LanguageSwitcherProps) => {

    const {
        value,
        options,
        onChange,
        style,
        width = 100,
        dropDownWidth = 200,
    } = props;

    return (
        <div>
            <div className={styles.langSwitcher}>
                <PlanetIcon className={styles.langSwitcherButton} />
                <SelectInput
                    id={"lang-switcher"}
                    style={{
                        "--select-border": "none",
                        "--select-border-focus": "none",
                        "--select-box-shadow-focus": "none",
                        "--select-input-background-color": "transparent",
                        ...style,
                    } as React.CSSProperties}
                    value={value}
                    options={options}
                    icon={
                        <TickIcon
                            style={{ "--tick-icon-margin": `${width-10}px` } as React.CSSProperties}
                            fillColor={'var(--secondary-color)'}
                            className={classNames(styles.tickIcon)}
                        />}
                    onChange={onChange}
                    wrapperClassName={classNames(styles.selectComponent)}
                    width={width}
                    dropDownWidth={dropDownWidth}
                />
            </div>
        </div>
    );
};

export default LanguageSwitcher;